export default {
  totalSalesBySegment: 'Total de {kpi} por Segmento',
  dataView: 'Vista de Datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como Imagen'
}
